export const ms = {
  store: "Store",
  meal: "Meal",
  users: "Users",
  user: "User",
  layout: "Layout",
  analytics: "Analytics",
  settings: "Settings",
  storeDetails: "Store details",
  advanced: "Advanced",
  name: "Name",
  quantity: "Quantity",
  address: "Address",
  email: "Email",
  phone: "Phone",
  galleryForCustomer: "Gallery/Advertisement for Customer Facing Screen",
  customMealCategory: "Custom Meal Category",
  storeType: "Store Type",
  currency: "Currency",
  add: "Add",
  print: "Print",
  sessions: "Sessions",
  orders: "Orders",
  customerFacingScreen: "Customer Facing Screen",
  cashierView: "Cashier View",
  kitchenView: "Kitchen View",
  layoutView: "Layout View",
  history: "History",
  noOrderRecordsExist: "No order records exist",
  noSessionRecordsExist: "No session records exist",
  updateMenu: "Update Menu",
  updateMenuSuccessfully: "Update menu successfully",
  updateMenuTooltip:
    "Upload the latest menu to server after every modification to your meals",
  serving: "Serving",
  active: "Active",
  inactive: "Inactive",
  amount: "Amount",
  total: "Total",
  table: "Table",
  payment: "Payment",
  changeDue: "Change Due",
  printReceipt: "Print Receipt",
  cancel: "Cancel",
  complete: "Complete",
  edit: "Edit",
  delete: "Delete",
  update: "Update",
  deleteOrder: "Delete order",
  printOrderSlip: "Print Order Slip",
  printKitchenSlip: "Print Kitchen Slip",
  latestOrderAt: "Latest order at",
  completedAt: "Completed at",
  received: "Received",
  startEditing: "Start Editing",
  save: "Save",
  addSmallDiningTable: "add small dining table",
  addMediumDiningTable: "add medium dining table",
  addLargeDiningTable: "add large dining table",
  clearAll: "clear all",
  undo: "undo",
  reorder: "reorder",
  renew: "Renew",
  renewSession: "Renew Session",
  createNewSession: "Create New Session",
  addSession: "Add Session",
  createSession: "Create Session",
  printSession: "Print QR Code",
  takeOrder: "Take Order",
  editOrder: "Edit Order",
  completeOrder: "Complete Order",
  description: "Description",
  ingredients: "Ingredients",
  price: "Price",
  category: "Category",
  createdDate: "Created Date",
  lastUpdated: "Last Updated",
  lastUpdatedAt: "Last updated at",
  admins: "Admins",
  members: "Members",
  invited: "Invited",
  owner: "Owner",
  member: "Member",
  admin: "Admin",
  adminsTooltip:
    "Only Super Admin (Store's owner) can grant and remove admin role",
  membersTooltip:
    "Member is authorized to only view and  manage customer's order.",
  invitedTooltip:
    "Invited people will be given [Member] role once invitation is accepted.",
  invitedPeople: "Invited People",
  transferOnwership: "Transfer ownership",
  removeAdminRole: "Remove admin role",
  grantAdminRole: "Grant admin role",
  invitePeople: "Invite people",
  addStore: "Add Store",
  alreadyExists: "already exists",
  existingInvitationTo: "Existing invitation to",
  emailIsRequired: "Email is required",
  nameIsRequired: "Name is required",
  priceIsRequired: "Price is required",
  invalidEmailAddress: "Invalid email address",
  fullService: "Full Service",
  limitedService: "Limited Service",
  storeTypeDescription:
    "Changing store type will affect how cashier view display and complete each order.",
  limitedServiceDescription:
    "Limited service manage orders as one order per submission. (e.g., food/beverage kiosk, food court)",
  fullServiceDescription:
    "Full service manage orders as one order per table/session. (e.g., restaurant, cafe)",
  fullServiceExplain:
    "Full serivice provide full dining experience and customer usually pay after dining. (e.g., restaurant, cafe)",
  limitedServiceExplain:
    "Limited service usually end their customer interaction(serving & payment) pre/on meals served. (e.g., food/beverage kiosk, food court)",
  orderIsEmpty: "Order is empty",
  completedByKitchen: "Completed by kitchen",
  changeMealImage: "Change Meal Image",
  uploadMealImage: "Upload Meal Image",
  food: "Food",
  drink: "Drink",
  side: "Side",
  submitted: "Submitted",
  confirmDeleteMeal: "Confirm delete meal?",
  confirmRenewSession: "Session is still valid, confirm renew session?",
  confirmCompleteOrder: "Confirm complete order?",
  confirmDeleteSession: "Confirm delete session?",
  confirmDeleteImage: "Confirm delete image?",
  storeInvitation: "Store Invitation",
  noInvitationFound:
    "No invitation found, please request authorization from store's admin",
  join: "Join",
  joinStore: "Join store",
  settingUpStore: "Setting up your store",
  createStore: "Create Store",
  invitation: "Invitation",
  uploadProfilePicture: "Upload Profile Picture",
  changeProfilePicture: "Change Profile Picture",
  myStores: "My Stores",
  profile: "Profile",
  accountSettings: "Account Settings",
  signOut: "Sign out",
  deleteStore: "Delete Store",
  cloneStore: "Clone Store",
  uploadImage: "Upload Image",
  temporarySession: "Temporary (session will be expired within 24 hours)",
  deleteSessionOnCompletion: "Delete session on order complete",
  autoRenew:
    "Automatically renew session on order complete (delete session is required)",
  limitedServiceSession:
    "Session expiration and deletion have been disabled to fit limited-service operation, you can configure your preference of session behavior below",
  noExistingNameFound: "Create session here then create table at ",
  ifYouWantLink: " to link session and table in Layout View",
  noOptions: "No Options",
  addCustomerGallery: "Add Screen Advertisement/Gallery",
  grantAdminRoleToast: "has been granted [Admin] role",
  removeAdminRoleToast: "has been move to member list",
  deleteInvitationToast: "has been removed from invitation list",
  deleteMemberToast: "has been removed from member list",
  deleteAdminToast: "has been removed from admin list",
  transferOnwershipToast: "store ownership transfer to",
  sendInvitationToast: "Successfully send invitation to",
  switchedStoreToast: "Switched to",
  deleteStoreToast: "Successfully deleted",
  recommendItToCustomer: "Recommend it to customer",
  emailUs: "Email us for any inquiry",
  emailUsShort: "Email",
  signup: "Signup",
  login: "Login",
  quitStore: "Quit Store",
  switchToStore: "Swith to store",
  changeLogo: "Change Logo",
  uploadLogo: "Upload Logo",
  emailVerifiedToast: "Your email has been verified!",
  emailSentToast: "Email sent!",
  emailSentToastDescription: "Please check your email for verification",
  emailVerificationErrorToast: "Verification Email already sent",
  emailVerificationFailedToast: "Failed to send Verification Email",
  resetPasswordToast:
    "Thanks, check your email for instructions to reset your password",
  emailNotExist: "Email not exist",
  failedToUpload: "Failed to upload",
  saveLayoutToast: "table layout has been updated",
  invalidEmailOrPassword: "Invalid Email or Password",
  failedToLogin: "Failed to login",
  verificationEmailSent: "Verify your e-mail",
  verficiationEmailSentDescription:
    "To complete your account registration process we must verify that the email address belongs to you.",
  emailAlreadyExist: "Email already exist",
  successfullyCreateStore: "Successfully create store ",
  pleaseSwitchStore: ", please switch to your new store.",
  pleaseCreateMeal: ", please proceed to create meals for your store.",
  youAreNowMemberOf: "You are now member of",
  orderFromTable: "Order from table",
  isCompleted: "is completed",
  addedCategory: "Added category",
  removedCategory: "Removed category",
  currencyChanged: "Currency has been changed to",
  successfullyUpdateStore: "Successfully updated store",
  storeTypeChanged: "Store type changed to",
  layoutNotReady: "Layout not ready...",
  layoutNotReadyDescription:
    "You haven't created your layout yet, please proceed to create layout for your store.",
  createLayout: "Create Layout",
  confirmQuitStore: "Confirm quit store?",
  minimumItemQuantity: "Minimum decimal of order quantity",
  noMoreOrder: "There are no more order",
  loadMore: "Load more",
  id: "ID",
  notifications: "Notifications",
  noNotificationFound: "No notification found",
  allowMemberEdit: "Allow member to edit orders",
  storeCreated: "Store created",
  storeCreatedNotification:
    "You have successfully set up your store, please proceed to create meals for your store.",
  manageSubscription: "Manage Subscription",
  billing: "Billing",
  currentSubscription: "Current Subscription",
  mySubscription: "My Subscription",
  initiateSubscription:
    "If you are a store owner, please proceed to create store first.",
  selectYourStoreType: " Select your store type",
  configureStoreTypeInfo:
    "Store type can be reconfigured later if you are not sure which to choose.",
  compulsoryItem: "Automatically added and immutable quantity",
  compulsory: "Compulsory",
  yes: "Yes",
  no: "No",
  hiddenFromMenu: "Hidden from menu",
  dashboard: "Dashboard",
  addedPaymentMethod: "Added payment method",
  removedPaymentMethod: "Deleted payment method",
  paymentMethod: "Payment Method",
  paymentMethods: "Payment Methods",
  options: "Options",
  summarized: "Summarized",
  unit: "Unit",
  unitPlaceHolder: "Unit for display purpose (e.g., gram, kg, sets)",
  totalAmount: "Total Amount",
  checkout: "Checkout",
  back: "Back",
  close: "Close",
  remark: "Remark",
  orderSettings: "Order",
  paymentKitchenOrder: "Served first / Payment first",
  paymentFirst: "Payment first",
  servedFirst: "Served first",
  alwaysCompleteAtKitchenView:
    "For Payment-First operation, complete your order at Kitchen View everytime after payment.",
  paymentFirstWarning:
    "Select Payment-First for Full-Service may cause unexpected behaviour",
  paymentKitchenExplained:
    "Only select the payment-first option to prevent order being removed after payment.  This is useful if your staff require to read info in kitchen view (e.g., ingredients)",
  tableName: "Session / Layout's table name",
  storeOperation: "Store Operation",
  sessionControl: "Session Control",
  all: "Complete",
  simple: "Simple",
  sessionControlExplained:
    "With [Simple] session control, you will not able to [Add new session], [Delete session], [Renew session] and [Print session] in [Cashier View], so please setup your session configuration properly before changing to [Simple] session control.",
  none: "None",
  nearest: "Nearest",
  up: "Up",
  down: "Down",
  roundingTotal: "Rounding Total Price",
  roundingItem: "Rounding Item Price",
  changeTo: "Changed to",
  allSessionControl: "Complete Session Control",
  simpleSessionControl: "Simple Session Control",
  requiredTableName:
    "Request Staff/Customer to insert table name (Not relatable to Layout's table) on checkout",
  pleaseInsertTableName: "Please insert your table name",
  session: "Session",
  inheritFromStore: "Inherit from store",
  customerScreen: "Customer screen",
  recentOrders: "Recent Orders",
  standard: "Standard",
  standardMenuControl: "Standard Menu Control",
  simpleMenuControl: "Simple Menu Control",
  menuControl: "Staff Menu",
  completePaymentFirstAlert: "Please complete payment at [Cashier View] first",
  detail: "Detail",
  detailNotExists: "Order detail no longer exists",
  addedRemarkShortcut: "Added remark shortcut",
  removedRemarkShortcut: "Removed remark shortcut",
  remarkShortcuts: "Remark shortcuts",
  paymentMethodNameIsRequired: "Payment method name is required",
  paymentMethodAlreadyExisted: "Payment method already existed",
  categoryNameIsRequired: "Category name is required",
  categoryAlreadyExisted: "Category already existed",
  shortcutNameIsRequired: "Shortcut name is required",
  shortcutAlreadyExisted: "Shortcut already existed",
  shortcut: "Shortcut",
  createOption: "Create option",
  optionName: "Option name",
  requireChange: "Require change calculation on payment",
  menuSettings: "Menu",
  paymentSettings: "Payment",
  submittingOrder: "Submitting order...",
  submittedOrder: "Successfully submitted the order!",
  addMeal: "Add Meal",
  createdFirstMeal: "Create First Meal",
  pleaseUpdateMenu:
    "You have successfully created your first meal, please click here to update your menu after completely setup your meals.",
  pleaseCreateSession:
    "Please proceed to [Cashier View] to create your first session/table.",
  storeSetupComplete: "Setup Session Successfully",
  moreStoreConfiguration:
    "Press on the QR code to start taking order, or print QR code for your customer to make order. Proceed to [Settings] section to update more specific store configuration to match your store operation perfectly.",
  ok: "Okay",
  features: "Features",
  others: "Others",
  kitchen: "Kitchen View",
  hasBeen: "has been ",
  enabled: "enabled",
  disabled: "disabled",
  untickToDisable: "Untick to disable feature",
  printAfterCompletion: "Print after order complete",
  userDecide: "User decide",
  alreadyAMember: "Already a member?",
  sign_up: "Sign Up",
  log_in: "Log In",
  password: "Password",
  confirmPassword: "Confirm Password",
  passwordMustBe6: "Password must be at least 6 characters long",
  required: "Required",
  passwordUnmatched: "Password Unmatched",
  forgotPassword: "Forgot password?",
  OR: "OR",
  signInWithGoogle: "Sign in with Google",
  forgotPasswordInfo: "You'll get an email with a reset link",
  resetPassword: "Reset Password",
  verifyYourEmail: "Verify your email address",
  check: "Check",
  toVerify: "to verify your account and get started.",
  ifYouHaveNotReceived:
    "If you have not received the email after a few minutes, please check your spam folder",
  resendVerificationEmail: "Resend Verification Email",
  refresh: "Refresh",
  startNow: "Start Now",
  freeUnlimitedUsers: "Free. Unlimited Users.",
  etilhubDescription:
    "A lite POS solution to run your restaurant and F&B business efficiently.",
  cloudSmart: "Cloud-based | Smart",
  pointOfSale: "Point of Sale",
  registerForFree: "Register for free",
  qrFoodOrdering: "QR Food Ordering",
  contactlessOrders: "Contactless Orders",
  instantAndEasySetup: "Instant and Easy to setup",
  adjustableForEveryBusiness: "Adjustable for every F&B business model",
  billingProcessingPrinting: "Billing processing & printing",
  orderSlipPrinting: "Order slip printing",
  issueReceipt: "Issue printed or electornic receipts",
  sessionQRPrinting: "Session QR code printing",
  instantKitchenView: "Instant kitchen view",
  realtimeOrderStatus: "Real-time order status",
  orderQueue: "Order queue",
  ingredientsDisplay: "Ingredients display",
  customizableFloorPlan: "Customizable floor plan",
  restaurantTableLayout: "Restaurant table layout",
  realtimeTableStatus: "Real-time table status",
  intuitiveInterface: "Intuitive interface",
  moreFeatures: "More features",
  comingsoon: "coming soon...",
  noItemExist: "No item records exist",
  myStore: "My Store",
  logout: "Logout",
  navigationSettings: "Navigation Settings",
  navigateToPaymentAfterSubmit:
    "Navigate to payment after order submitted (Cashier View)",
  size: "Size",
  small: "Small",
  medium: "Medium",
  large: "Large",
  tableNameMustBeSame:
    "Table name must be same as session name, you can create table here first before proceed to create session for your store. ",
  confirmDeleteStore:
    "Confirm that you want to delete this store by typing its name:",
  deleteThisStore: "Delete this store?",
  deleteStoreWarning:
    "Doing so will permanently remove the store and unable to recover in the future.",
  pleaseInsertStoreName: "Please insert store name",
  cloneThisStore: "Clone store",
  cloneStoreInfo: "Update details for your new store.",
  addIngredient: "Add Ingredient",
  orderUpdatedAt: "Order updated at table",
  simpleMenuInfo:
    "Note: Simple Menu has limitation of selecting multiple option for each meal.",
  fiverr: "Fiverr",
  bySigningUp: "By signing up, you agree to our",
  privacyPolicy: "Privacy Policy",
  termsAndConditions: "Terms & Conditions",
  and: "and",
  storeExceedSubscriptionLimit:
    "Number of store exceed subscription limit, update your plan to add more store.",
  someStoreIsNotShowing:
    "Some store is not showing due to expiration of your subscription.",
  currentPeriodStart: "Current period start",
  currentPeriodEnd: "Your plan renews on",
  planCanceledOn: "Your plan will be canceled on",
  storeQuantity: "Store Quantity",
  dailyOrder: "Daily order limit",
  perStore: "per store",
  createdBy: "Created by",
  completedBy: "Completed by",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  morePrices: "More prices in Options",
  moreIngredients: "More ingredients in Options",
  all_: "All",
  filter: "Filter",
  expired: "Expired",
  updated: "Updated",
  limitTime: "Limit Time",
  limitDay: "Limit Day",
  outOfStock: "Out of stock",
  startFrom: "Start from",
  endAt: "End at",
  hour: "Hour",
  hours: "Hours",
  default: "Default",
  cloud: "Cloud",
  printMethod: "Print Method",
  sessionCreated: "Session created",
  orderCreated: "Order created",
  event: "Event",
  eventDescription: "Select the types of events to trigger webhooks",
  endPointDescription:
    "Enter the URL at which you wish to receive the webhooks",
  webhookDescription:
    "We will submit a POST request to this URL with a JSON object representing the event data for any events you choose to be triggered",
  testEndpointUrl: "Test Endpoint URL",
  failedToPrint: "Failed to print",
  secretKeyDescription:
    "Secret key will be used to sign with HTTP body using HMAC-SHA256 and contained in header named X-Hub-Signature",
  outGoingWebhooks: "Outgoing Webhooks",
  urlIsRequired: "URL is required",
  invalidUrl: "Invalid URL",
  endpointUrl: "Endpoint URL",
  addWebhook: "Add Webhook",
  confirmDeleteWebhook: "Confirm delete webhook?",
  printButtonClick: "Dapur",
  somethingWentWrong: "Sesuatu telah berlaku",
  welcomeBack: "Selamat kembali",
  pleaseWait: "Sila tunggu",
  sessionCheckInProgress: "Pemeriksaan sesi sedang berlangsung",
  noSuchTable: "Maaf, meja tersebut tidak wujud!",
  waitingForStaff: "Menunggu kakitangan membuka meja untuk anda ...",
  scanQRCodeAgain: "Sila imbas kod QR sekali lagi untuk memesan atau mengakses menu!",
  bonAppetit: "Selamat menjamu selera!",
  modalSelectLanguage: "Pilih Bahasa",
  sessionNotProvided: "Tiada sesi disediakan",
  noStoreIdProvided: "Tiada ID kedai dalam sesi",
  storeNotConfigured: "Kedai tidak dijumpai",
  failedToLoadData: "Gagal memuat data",
  orderNumber: "Pesanan #",
  orderCreated: "Dibuat",
  orderTotal: "Jumlah Pesanan",
  totalWithTaxes: "Jumlah dengan Cukai",
  customerName: "Nama",
  totalFor: "Jumlah untuk",
  noOrders: "Tiada Pesanan",
  grandTotal: "Jumlah Keseluruhan",
  pastOrders: "Pesanan Lepas",
  poweredBy: "Dikuasakan oleh",
  closeButton: "Tutup",
  thisSelectionIsRequired: "Pilihan ini diperlukan",
  pleaseSelectAtLeast: "Sila pilih sekurang-kurangnya",
  maximumSelections: "Maksimum",
  selectionsAllowed: "pilihan dibenarkan",
  optionItems: "pilihan",
  customizeYourOrder: "Sesuaikan Pesanan Anda",
  totalExtra: "Jumlah Tambahan",
  cancelButton: "Batal",
  addToCart: "Tambah ke Troli",
  selectExactly: "Anda perlu memilih tepat",
  singleItem: "item",
  selectRange: "Pilih",
  rangeTo: "hingga",
  selectAtLeast: "Pilih sekurang-kurangnya",
  selectUpTo: "Pilih sehingga",
  selectMultipleOptional: "Pilih berbilang (Pilihan)",
  selectOneRequired: "Pilih satu (Diperlukan)",
  requiredOption: "Diperlukan"
};
